import React, { useEffect, useContext, useMemo, useState } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _some from 'lodash/some';
import _set from 'lodash/set';
import _head from 'lodash/head';
import _findIndex from 'lodash/findIndex';
import classNames from 'classnames';
import { AppContext } from '../../store/contexts/AppContext.js';
import { NavigationContext } from '../../store/contexts/NavigationContext.js';
import { useParams } from 'react-router-dom';
import { useUpdateEffect } from '_ui-core-js/React/hooks/useUpdateEffect.js';
import { useFirstRender } from '_ui-core-js/React/hooks/useFirstRender.js';
import { AtmosphereEditorial, NewsAndStories, NextStepsSection, Showroom, Signpost, VideoBanner, VideoHero } from '../../components';
import { AtmosphereBanner } from '../../partials';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { createCustomShowroomItems, combineAndOrderItems } from '../../helpers/showroom';

export function CustomizedSceen(props) {

    const { 
        labels, 
        customerProfile, 
        settings, 
        userPreferences, 
        webglConfigurations, 
        setWebglConfigurations,
        guestPromptRendered  
    } = props;

    const { navigateToActions } = useContext(NavigationContext);
    const { navigateToInspirationAndGallery, navigateToStyleSelector } = navigateToActions
    
    const { 
        showGalleryPrompt,
        showVideoBanner,
        showShowroom,
        showReservePrompts,
        showNewsAndStories,
        showNextSteps,
        showYourAtmosphere,
        showAiSignPosting,
        show360ExperienceLinks
    } = settings;     
    
    const { 
        setSelectedAtmosphere,
        selectedAtmosphere,
        locale,
        userToken 
    } = useContext(AppContext);

    const user = { 
        locale, 
        token:userToken, 
        webglConfigurations, 
        setWebglConfigurations
    };

    const isFistRender = useFirstRender();
    const { sectionId } = useParams();

    const isInjected = _get(settings, 'isInjected', false);
    
    const firstName = _get(customerProfile, 'firstName', '');
    const atmosphere = _get(userPreferences, 'atmosphere', '');
    const heroLabels = _get(labels, 'personalised-hero', {});
    const reservePromptLabels = _get(labels, 'reserve-prompt', {});
    const galleryPromptLabels = _get(labels, 'gallery-prompt', {});
    const galleryPromptPicture = _get(galleryPromptLabels, `assets.${atmosphere}`, {});
    const showroomLabels = _get(labels, 'showroom', {});
    const aiExperiencePromptLabels = _get(labels, 'ai-experience-prompt', {});
    const newsAndStoriesLabels = _get(labels, 'news-and-stories', {});
    const cityEventsLabels = _get(labels, 'city-events', {});
    const videoBannerLabels = _get(labels, `video-banner.${atmosphere}`, _get(labels, `video-banner.default`, {}));
    const atmosphereEditorialLabels = _.get(labels, `your-atmosphere.${atmosphere}`, _get(labels, `your-atmosphere.default`, {}));
    const nextStepsLabels = _.get(labels, 'next-steps', {});
    const [showroomItems, setShowroomItems] = useState(
        _filter(showroomLabels.items, item => _some([item.name === atmosphere.toUpperCase(), item.name === 'NEW SAVE']))
        );
    const customTemplate = _head(_filter(showroomLabels.items, item => item.name === 'CUSTOM'));
    const customShowroomItems = createCustomShowroomItems(webglConfigurations, customTemplate);
    const combinedShowroomItems = useMemo(() => combineAndOrderItems(showroomItems, customShowroomItems), [showroomItems, customShowroomItems] );
    const [newsAndEvents, setNewsAndEvents] = useState({}) 
    const block = 'c-customised-screen';
        
    useEffect(() => {
        const updatedShowroomItems = [...showroomItems];

        const recommendedItemIndex = _findIndex(showroomItems, { name:atmosphere.toUpperCase()} );

        if (recommendedItemIndex !==-1) {
            updatedShowroomItems[recommendedItemIndex] = {...updatedShowroomItems[recommendedItemIndex], 'recommended':showroomLabels.recommended };
        }

        setShowroomItems(updatedShowroomItems);

    }, [atmosphere, showroomLabels, setShowroomItems]);

    useEffect((()=>{
        const content = {};
        const newsAndStoriesItems = _.get(newsAndStoriesLabels, 'carousel.items', []); 
        const cityEventsItems =_.get(cityEventsLabels, 'carousel.items', []);
        const combinedItems = newsAndStoriesItems.concat(cityEventsItems);

        _.set(content, 'intro', newsAndStoriesLabels.intro)
        _.set(content, 'carousel.items', combinedItems)

        setNewsAndEvents(content)

    }), [newsAndStoriesLabels, cityEventsLabels])

    useUpdateEffect(() => {

        function scrollToSection (element) {
            if (element) {
                element.scrollIntoView({behavior : 'smooth'});
            }
        };
        
        const targetElement = document.getElementById(sectionId);
        scrollToSection(targetElement);

    }, [sectionId, isFistRender]);

    useEffect(() => {
      fireGTMTrackingEvent({
        name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
        componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxYourExperience, 
        componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
        action: CORE_GTM_TRACKING_VALUES.action.homeScreen,
        label: userPreferences.personality
      }, {
        workflow: {
          name: LBX_GTM_TRACKING_VALUES.componentName.lbxYourExperience,
          step: CORE_GTM_TRACKING_VALUES.action.homeScreen,
          conversion: 0,
          variant: userPreferences.personality
        }
      });
    }, []);
    
    return (
            <div id='personal-page-customised-view' className={classNames({
                [`${block}--blur-background`]:guestPromptRendered
            })}>
             <VideoHero {...{
                ...heroLabels, 
                atmosphere, 
                firstName, 
                isInjected,
                navigateToStyleSelector 
            }}/>
            {showShowroom && 
                <Showroom {...{
                    title: _.get(showroomLabels, 'curated-title', ''), 
                    subtitle:_.get(showroomLabels, 'curated-subtitle', ''),
                    items: combinedShowroomItems,
                    startPosition: 0,
                    onCardChange: () => { setSelectedAtmosphere(atmosphere)},
                    isInfiniteScroll: false,
                    inheritParentTheme: false,
                    selectedAtmosphere,
                    user,
                    deleteModal: _.get(showroomLabels, 'delete', {}),
                    showReservePrompts: !!showReservePrompts,
                    show360ExperienceLinks: !!show360ExperienceLinks
                }}/>
            }
            {showGalleryPrompt && 
                <NextStepsSection {...{
                    id: 'gallery',
                    blocks:[
                        {
                            ...galleryPromptLabels,
                            picture:galleryPromptPicture
                        }
                    ]
                }}/>
            }
            {showVideoBanner && 
                <VideoBanner {...{
                    id:'film',
                    ...videoBannerLabels,
                    settings
                }}/>
            }
            {showYourAtmosphere && 
                <AtmosphereEditorial {...{
                    ...atmosphereEditorialLabels,
                    atmosphere,
                    inheritParentTheme: true
                }}/>
            }
            {showReservePrompts && 
                <AtmosphereBanner {...{
                    ...reservePromptLabels,
                    theme:' lbx',
                    inheritParentTheme: true,
                    gtmComponentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceReserveToday, 
                    gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
                    gtmAction: CORE_GTM_TRACKING_VALUES.action.homeScreen,
                    gtmLabel: CORE_GTM_TRACKING_VALUES.label.onlineCarReservation
                }}/>
            }
            { showAiSignPosting && 
                <Signpost {...{
                    ...aiExperiencePromptLabels,
                    onClickCallbackSecondary: navigateToInspirationAndGallery
                }}/>
            }
            {showNewsAndStories && 
                <NewsAndStories {...{
                    ...newsAndEvents
                }}/>
            }
            {showNextSteps &&
                <NextStepsSection {...{
                    title: _.get(nextStepsLabels, 'title'), 
                    subtitle: _.get(nextStepsLabels, 'subtitle'), 
                    blocks:_.get(nextStepsLabels, 'blocks', []), 
                    layout:_.get(nextStepsLabels, 'layout','vertical')
                }}/>
            }
        </div>
    )
}